export default __webpack_public_path__ + "static/media/kaminfeuer_web-lg@2x.699f819e.webp";